import { CModal, CModalBody, CModalHeader } from "@coreui/react";

import PropTypes from "prop-types";
import React, { useState } from "react";
import { UserAPIKeyBadge } from "../../views/users/UserProfile";
import { CopyToClipboardBadge } from "src/reusable/CopyToClipboard";
import { Button } from "@mui/material";
import { grey } from "@mui/material/colors";

const prependBaseUrl = (path) => {
  path = path.replace("as_csv=true", "as_json=true");

  // Check if the path starts with 'http'
  if (!path.startsWith("http")) {
    // Get the base URL from the browser window
    const baseUrl = window.location.origin; // e.g. "http://localhost:3000"
    return `${baseUrl}${path}`;
  }

  // If it doesn't start with http, return the original path
  return path;
};

export const PowerBIButton = (props) => {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <>
      <Button
        className="powerbi-data-button"
        variant="contained"
        disableElevation
        color="inherit"
        startIcon={
          <img
            src={"/svgs/Power-BI.svg"}
            alt="PowerBI"
            style={{ height: "22px", marginRight: "5px" }}
          />
        }
        sx={{
          bgcolor: grey[900],
          color: grey[50],
          "&:hover": {
            bgcolor: grey[800],
          },
        }}
        onClick={() => {
          setShowModal(true);
        }}
        disabled={props.disabled}
      >
        Power BI
      </Button>

      {showModal && (
        <div
          style={{
            position: "absolute",
            textAlign: "left",
          }}
        >
          <PowerBIDataModal
            isVisible={showModal}
            onClose={() => setShowModal(false)}
            url={props.url}
            message={props.message}
            forPage={props.forPage}
          />
        </div>
      )}
    </>
  );
};

PowerBIButton.propTypes = {
  url: PropTypes.string.isRequired,
  forPage: PropTypes.string.isRequired,
  message: PropTypes.string,
  disabled: PropTypes.bool,
};

PowerBIButton.defaultProps = {
  buttonStyle: {},
  buttonSize: "md",
  disabled: false,
};

export const PowerBIDataModal = (props) => {
  const [, setShowApiKey] = useState(false);
  const getVisibility = (visibility) => {
    setShowApiKey(visibility);
  };

  const finalUrl = prependBaseUrl(props.url);

  return (
    <CModal
      show={props.isVisible}
      onClose={props.onClose}
      data-testid="ds-powerbi-modal"
    >
      <CModalHeader>
        <h4 id="connect-to-powerbi-header">
          Connect Power BI{!!props.message && props.message}
        </h4>
      </CModalHeader>
      <CModalBody>
        <ol>
          <li style={{ fontSize: "115%" }}>
            <div>
              <div>
                In Power BI, add a new {'"Web"'} datasource by selecting{" "}
                {'"Get Data -> Web"'}
              </div>
              <div
                style={{
                  textAlign: "center",
                  overflow: "auto",
                }}
              >
                <img
                  src={
                    "/images/product-photos/tutorials/powerbi-getdata-web.png"
                  }
                  alt="Get Data -> Web"
                  style={{
                    height: "100px",
                    margin: "20px",
                    boxShadow:
                      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                  }}
                />
              </div>
            </div>
          </li>
          <li style={{ fontSize: "115%" }}>
            <div>
              <div>
                Select the {'"'}Advanced{'"'} option and enter the following:
              </div>
              <div style={{ fontSize: "90%", marginTop: "7px" }}>
                <ul>
                  <li style={{ wordBreak: "break-all" }}>
                    URL parts: <b>{finalUrl}</b>
                    <CopyToClipboardBadge
                      valueToCopy={finalUrl}
                      data-testid="ds-powerbi-btn-copy-url"
                    />
                  </li>
                  <li>
                    HTTP request header parameters (optional):
                    <table
                      style={{
                        borderCollapse: "collapse",
                        display: "inline-table",
                      }}
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "2px 5px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <b>X-API-KEY</b>
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "2px 5px",
                              fontSize: "100%",
                            }}
                            data-testid="ds-powerbi-btn-copy-key"
                          >
                            <UserAPIKeyBadge getVisibility={getVisibility} />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </li>
                </ul>
              </div>
              <div
                style={{
                  textAlign: "center",
                  overflow: "auto",
                  marginTop: "15px",
                }}
              >
                {props.forPage === "datasets" && (
                  <img
                    src={
                      "/images/product-photos/tutorials/powerbi-getdata-advanced.png"
                    }
                    alt="Get Data -> Web"
                    style={{
                      height: "100px",
                      margin: "20px",
                      boxShadow:
                        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                    }}
                  />
                )}
                {props.forPage === "automationRecords" && (
                  <img
                    src={
                      "/images/product-photos/tutorials/powerbi-getdata-advanced-automation-records.png"
                    }
                    alt="Get Data -> Web"
                    style={{
                      height: "260px",
                      margin: "20px",
                      marginLeft: "auto",
                      marginRight: "auto",
                      boxShadow:
                        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                    }}
                  />
                )}
              </div>
            </div>
          </li>
          <li style={{ fontSize: "115%" }}>
            <div>
              Click {'"Ok"'} and wait, and the table should get created!
            </div>
          </li>
        </ol>
      </CModalBody>
    </CModal>
  );
};

PowerBIDataModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  forPage: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.string,
};
